;(function () {
    function EnergyCalculatorTracking() {
        /**
         * local object availability
         * @type {EnergyCalculatorTracking}
         * @private
         */
        var _this = this

        /**
         * The order widget
         */
        this.orderWidget = document.querySelector('order-widget-app')

        /**
         * The mapping of the calculator categories to the calculator actions
         * @type {{ELECTRICITY_CHARGING: string, GAS: string, ELECTRICITY: string, ELECTRICITY_HEATING: string}}
         */
        this.categoryMapping = {
            GAS: 'Erdgasrechner',
            ELECTRICITY: 'Stromrechner',
            ELECTRICITY_HEATING: 'Wärmestrom',
            ELECTRICITY_CHARGING: 'Ladestrom',
        }

        /**
         * Add the submit event to the opened tab form
         * To ensure the form is fully loaded when we change the tab, we have a small delay of 200ms
         */
        this.addTrackingEventToOpenedTab = function () {
            setTimeout(() => {
                const activeTabElement = this.orderWidget.querySelector('.nav-link.active')
                const tabForm = this.orderWidget.querySelector('form')
                if (tabForm) {
                    tabForm.addEventListener('submit', () => {
                        _this.cbTrackingFunction(activeTabElement)
                    })
                } else {
                    this.addTrackingEventToOpenedTab()
                }
            }, 200)
        }

        /**
         * Init the tracking for the Energy calculator
         * To ensure the widget is fully loaded, we have small delay of 500ms
         */
        this.init = function () {
            if (_this.orderWidget) {
                setTimeout(() => {
                    // Add tracking event to initial opened tab form
                    _this.addTrackingEventToOpenedTab()
                    // Everytime a user clicks another tab, we add the event listener to the new created form
                    const tabs = document.querySelectorAll('[ngbnavitem]')
                    tabs.forEach((tab) => {
                        const linkNode = tab.children[0]
                        linkNode.addEventListener('click', () => {
                            _this.addTrackingEventToOpenedTab()
                        })
                    })
                }, 500)
            }
        }

        /**
         * This callback function adds the actual tracking object
         */
        this.cbTrackingFunction = function (activeTabElement) {
            // Do not send tracking event when form contains field errors
            if (_this.orderWidget.querySelectorAll('.field-error').length > 0) {
                return
            }

            let currentCategory = _this.categoryMapping[activeTabElement.parentNode.getAttribute('ngbnavitem')]
            let zip = _this.orderWidget.querySelector('#zipcode').value

            try {
                if (dataLayer) {
                    dataLayer.push({
                        event_category: currentCategory,
                        event_action: 'Berechnen',
                        event_label: zip,
                        event: 'vEvent',
                    })
                }
            } catch (e) {
                console.log(e)
            }
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.Energy = window.Energy || {}
    window.Energy.EnergyCalculatorTracking = EnergyCalculatorTracking
})()

if (document.readyState !== 'loading') {
    new window.Energy.EnergyCalculatorTracking()
} else {
    document.addEventListener('DOMContentLoaded', new window.Energy.EnergyCalculatorTracking())
}
